<template>
    <div class="text-container" :class="{ complete: isComplete, vertical: isVertical, horizontal: !isVertical }">
        <div class="img-icon" :style="`background-image: url(${noticeData.imgUrl})`" @click="$parent.giveOutLink(noticeData.linkUrl)"></div>
        <div class="txt" @click="$parent.giveOutLink(noticeData.linkUrl)">
            <h1>{{ noticeData.title }}</h1>
            <div class="ql-editor content g-twoline" v-html="noticeData.content" ></div>
        </div>
        <span class="notice-close" @click="$parent.closeWindow"></span>
    </div>
</template>
<script>
export default {
    name: 'TextComponent',
    props: {
        noticeData: {
            required: true,
            type: Object
        },
        isVertical: {
            required: true,
            type: Boolean
        },
        isComplete: Boolean
    }
}
</script>
<style lang="less" scoped>
.text-container {
    position: fixed;
    display: flex;
    background-color: rgba(0, 0, 0, .75);
    box-sizing: border-box;
    height: 130px;
    color: #fff;
    opacity: 0;
    bottom: -30px;
    .img-icon {
        margin-right: 15px;
        flex: none;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
    }
    .txt {
        flex: auto;
        min-width: 10px;
        > h1 {
            font-size: 1.5em;
            font-weight: 500;
            line-height: 1.6;
            margin: .3em 1.5em .5em 0;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .content {
            line-height: 1.6;
            padding: 0;
            height: 3.3em;
            overflow: hidden;
        }
    }
    &.horizontal {
        width: 90%;
        left: 5%;
        padding: 10px 15px;
        border-radius: 1vw;
        .img-icon {
            width: 110px;
            height: 110px;
        }
        .txt {
            font-size: 14px;
        }
    }
    &.vertical {
        width: 100%;
        padding: 20px 8px;
        left: 0;
        .img-icon {
            width: 90px;
            height: 90px;
        }
        .txt {
            font-size: 13px;
        }
    }
    &.complete {
        opacity: 1;
        transition: all ease-out .2s;
        &.horizontal {
            bottom: 2vh;
        }
        &.vertical {
            bottom: 0;
        }
    }
}
.g-img-full {
    height: 100%;
    object-fit: contain;
    object-position: center;
}
</style>
